import { useEffect, useState } from 'react';

import Ivr from 'src/models/Ivrs/Ivr';
import ivrResource from 'src/actions/ivrs/ivrResource';
import ivrsTreeDataResource from 'src/actions/ivrs/ivrsTreeDataResource';
import { IvrTreeData } from 'src/models/Ivrs/IvrTreeData';
import replaceNotValidIvrIds from 'src/presentation/components/pages/ivr/components/ivrTree/helpers/replaceNotValidIvrIds';
import { STATUS_LOADING, STATUS_PERSISTING, STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';
import useDocumentResource, { useResourceValue } from 'src/presentation/hooks/useDocumentResource';

const useFetchIvrWithTreeData = ({ fetchData, id, version, setIsSaveInProgress }) => {
  const [config, setConfig] = useState<Ivr>();
  const [treeData, setTreeData] = useState<IvrTreeData>();
  const [loadingState, setLoadingState] = useState<string>();

  const {
    errors,
    loadingState: ivrConfigLoadingState,
    value: ivrConfig,
    persistingState: ivrPersistingState,
  } = useDocumentResource(ivrResource, {
    fetch: fetchData,
    params: { id, version: version },
  });

  const {
    loadingState: positionsLoadingState,
    value: ivrsTreeData,
    persistingState: treeDataPersistingState,
  } = useResourceValue<IvrTreeData>(ivrsTreeDataResource);

  useEffect(() => {
    const loadingState =
      ivrConfigLoadingState === STATUS_SUCCEEDED &&
      positionsLoadingState === STATUS_SUCCEEDED &&
      ivrPersistingState !== STATUS_PERSISTING &&
      treeDataPersistingState !== STATUS_PERSISTING
        ? STATUS_SUCCEEDED
        : STATUS_LOADING;

    if (loadingState === STATUS_SUCCEEDED) {
      const [configWithReplacedIds, newTreeData] = replaceNotValidIvrIds(ivrConfig, ivrsTreeData);

      setConfig(configWithReplacedIds);
      setTreeData(newTreeData);

      setIsSaveInProgress(false);
    }

    setLoadingState(loadingState);
  }, [
    ivrConfig,
    ivrConfigLoadingState,
    ivrPersistingState,
    ivrsTreeData,
    positionsLoadingState,
    setConfig,
    setIsSaveInProgress,
    setLoadingState,
    setTreeData,
    treeDataPersistingState,
  ]);

  return { loadingState, ivrsTreeData: treeData ?? {}, ivrConfig: config, errors };
};

export default useFetchIvrWithTreeData;
